// extracted by mini-css-extract-plugin
export var numberInputContainer = "_71-0";
export var startPickingButton = "_71-1";